import { render, staticRenderFns } from "./FilterManager.vue?vue&type=template&id=0bdaa22a&scoped=true&"
import script from "./FilterManager.vue?vue&type=script&lang=ts&"
export * from "./FilterManager.vue?vue&type=script&lang=ts&"
import style0 from "./FilterManager.vue?vue&type=style&index=0&id=0bdaa22a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdaa22a",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
